module.exports = __webpack_public_path__ + "img/clientes.f632745c.png";